import { useSelector, useDispatch } from "react-redux";
import { setDepositos, setDepositoSeleccionado, resetDepositos, selectDepositos, selectDepositoSeleccionado } from "../store/depositos/depositosSlice";

/**
 * Hook para el store de depósitos
 * Mantiene la misma API que el store de Zustand
 */
export const useDepositosStore = () => {
  const dispatch = useDispatch();
  const depositos = useSelector(selectDepositos);
  const depositoSeleccionado = useSelector(selectDepositoSeleccionado);

  return {
    depositos,
    depositoSeleccionado,
    setDepositos: depositos => dispatch(setDepositos(depositos)),
    setDepositoSeleccionado: deposito => dispatch(setDepositoSeleccionado(deposito)),
    resetDepositos: () => dispatch(resetDepositos()),
  };
};

// ===== Hooks específicos =====
export const useDepositos = () => useSelector(selectDepositos);
export const useDepositoSeleccionado = () => useSelector(selectDepositoSeleccionado);

export const useDepositosActions = () => {
  const dispatch = useDispatch();

  return {
    setDepositos: depositos => dispatch(setDepositos(depositos)),
    setDepositoSeleccionado: deposito => dispatch(setDepositoSeleccionado(deposito)),
    resetDepositos: () => dispatch(resetDepositos()),
  };
};

export default useDepositosStore;
